module.exports = __webpack_public_path__ + "media/images/help/wf-join-team-d30b6a1b8851e40533580821f1ead34c.png";